export enum SupportDisplayContexts {
    COLLECTION = 'COLLECTION',
    DROP_OFF = 'DROP_OFF'
}

export type SupportDisplayContext =
    SupportDisplayContexts.COLLECTION
    | SupportDisplayContexts.DROP_OFF;

export class SupportDisplayOptions {
    context: SupportDisplayContext;
    requiresManualAction: boolean = false;
}
